import React from 'react';
import { Item } from './PositionItemStyles';
import { Tooltip } from '@mui/material';

interface IProps {
  position: string;
  success: boolean;
  isFirstSuccess: boolean;
  isLastSuccess: boolean;
  error: boolean;
  isFirstError: boolean;
  isLastError: boolean;
}

export const PositionItem: React.FC<IProps> = (props) => {
  const { position, success, isFirstSuccess, isLastSuccess, error, isFirstError, isLastError } = props;

  return error ? (
    <Tooltip
      title='Duplicated position'
      arrow
      componentsProps={{ tooltip: { className: 'duplicated-position-tooltip' } }}
      placement='bottom'
    >
      <Item
        key={position}
        data-testid={position}
        data-testvalue={success}
        success={success}
        isFirstSuccess={isFirstSuccess}
        isLastSuccess={isLastSuccess}
        error={error}
        isFirstError={isFirstError}
        isLastError={isLastError}
      >
        {position}
      </Item>
    </Tooltip>
  ) : (
    <Item
      key={position}
      data-testid={position}
      data-testvalue={success}
      success={success}
      isFirstSuccess={isFirstSuccess}
      isLastSuccess={isLastSuccess}
      error={error}
      isFirstError={isFirstError}
      isLastError={isLastError}
    >
      {position}
    </Item>
  );
};
